/**
 * Created by dfontenla
 */
angular.module('CarsSaraBo').directive('categoryBanner', function () {
    return {
        scope: {
            visibility: '=',
            country: '@'
        },

        link: function (scope) {
            const FORM_URL = 'https://es.surveymonkey.com/r/Q57GGCY';
            var categoryBannerShow = ["20010"]

            scope.goToForm = function(){
                window.open(FORM_URL);
            }

            scope.showCategoryBanner = function(){
                return _.includes(categoryBannerShow, scope.country)
            }
        },
        templateUrl: 'assets/partial/notifications/category-banner.html'
    };
});


//////////////////
// WEBPACK FOOTER
// ./public/app/models/directives/category_banner_directive.js
// module id = 872
// module chunks = 3